import axios from 'axios';
import { get, set, unset } from 'lodash';
import userService from './user-service';
import dialogService from './dialog-service';
import history from '../history';
import { save as saveException } from './exception-service';
import {
  ERROR_TYPE_API,
  ERROR_TYPE_NETWORK,
  WARNING_TYPE_API,
  API_CALLING_TIMEOUT,
  API_CALLING_TERMINATE,
} from '../constants';

const apiClient = axios.create({ timeout: API_CALLING_TERMINATE });

if (process.env.REACT_APP_MOCK) {
  console.log('Mock Request');
  const mock = import(/* webpackChunkName: "mock" */ '../mock');
  mock.then(({ default: mockSetup }) => {
    mockSetup(apiClient);
  });
}

/* eslint-disable arrow-body-style */
apiClient.interceptors.request.use((config) => {
  set(config, 'startTime', Date.now());
  dialogService.loadingProgress.show();

  return config;
}, (err) => {
  dialogService.loadingProgress.hide();
  console.log('request timeout');

  return Promise.reject(err);
});

apiClient.interceptors.response.use((response) => {
  const errors = get(response, 'data.errors', null);
  dialogService.loadingProgress.hide();

  const duration = Date.now() - response.config.startTime;
  unset(response, 'config.startTime');

  if (duration > API_CALLING_TIMEOUT) {
    saveException('warning', [{
      message: `API ${Object.keys(response.data.data)} processed more than ${API_CALLING_TIMEOUT / 1000} seconds.`,
    }], WARNING_TYPE_API, response);
  }

  if (errors) {
    saveException('error', errors, ERROR_TYPE_API, response);
    console.log('api error', errors);
  }

  return response;
}, (err) => {
  dialogService.loadingProgress.hide();

  if (!err || !err.response) {
    if (err.code === 'ECONNABORTED') {
      const queryString = JSON.parse(err.config.data).query;
      const errorTitle = queryString.match(/[query,mutation].*?{[\\n\s]*(.+?)[\\n\s]*[(,{]/i)[1];
      set(err, 'status', 'ABORTED');
      saveException('error', [{
        message: `Enforce to terminate ${errorTitle} after processed for ${API_CALLING_TERMINATE / 1000} seconds.`,
      }], ERROR_TYPE_API, err);
    } else {
      console.log('server error');
      saveException('error', [err], ERROR_TYPE_NETWORK, err);
    }
  } else {
    switch (err.response.status) {
      case 401:
        userService.logout();
        break;
      case 403:
        history.push('/403');
        break;
      default:
        console.log('unknown errors');
        saveException('error', [err], ERROR_TYPE_NETWORK);
        break;
    }
  }

  return Promise.reject(err);
});

export default apiClient;
